<main
  class="shipping-and-delivery-component"
  [class.desktop]="!(lessThan$ | async)?.sm"
  [class.single-header]="!(lessThan$ | async)?.mobileXL"
  *transloco="let t">
  <div class="wrapper scroll" id="mainAppScroll">
    <div class="content">
      <article class="content-wrapper">
        <section class="flex flex-col">
          @if (lang !== 'AR') {
            <h1>Shipping and Delivery</h1>
          } @else {
            <h1>الشحن والتسليم</h1>
          }

          <span class="fixed-space-32" aria-hidden="true"></span>

          <div class="faq">
            @for (item of shippingFaqData; track item; let i = $index) {
              <div class="item">
                <div class="question" (click)="item.open = !item.open">
                  @if (lang !== 'AR') {
                    <span>{{ item.question }}</span>
                  }
                  @if (lang === 'AR') {
                    <span>{{ item.questionAr }}</span>
                  }
                  <span class="fixed-space-8" aria-hidden="true"></span>
                  <popsy-icon-chevron-down
                    class="icon icon fill-gray-01"
                    [class.selected]="item.open" />
                </div>
                @if (lang !== 'AR') {
                  <div
                    class="answer"
                    [class.selected]="item.open"
                    [innerHTML]="item.answer"></div>
                }
                @if (lang === 'AR') {
                  <div
                    class="answer"
                    [class.selected]="item.open"
                    [innerHTML]="item.answerAr"></div>
                }
                @if (i === 1 && item.open) {}
                <span class="line fill-row"></span>
              </div>
            }
          </div>

          <span class="fixed-space-64" aria-hidden="true"></span>

          <div class="popsy-card gray">
            @if (lang !== 'AR') {
              <h2>Need to track an order?</h2>
            } @else {
              <h2>بحاجة إلى تتبع الطلب؟</h2>
            }
            <span class="fixed-space-16" aria-hidden="true"></span>

            <a
              class="flex flex-col"
              [routerLink]="trackUrlFragment()"
              [queryParams]="queryParams$ | async">
              <button class="popsy-button-primary">
                @if (lang !== 'AR') {
                  Track order
                } @else {
                  تتبع الطلب
                }
              </button>
            </a>
            <span class="fixed-space-16" aria-hidden="true"></span>
            @if (lang !== 'AR') {
              <span
                >You will need your order ID number. It can be found on your order
                confirmation email.
              </span>
            } @else {
              <span
                >ستحتاج إلى رقم التعريف الخاص بطلبك. يمكنك إيجاده في البريد الإلكتروني
                الخاص بتأكيد الطلب.
              </span>
            }
            <span class="fixed-space-16" aria-hidden="true"></span>
          </div>
          <app-other-topics></app-other-topics>

          <span class="fixed-space-64" aria-hidden="true"></span>
        </section>
      </article>
      @if ((lessThan$ | async)?.mobileL !== true) {
        <span class="fixed-space-64" aria-hidden="true"></span>
      }
      @if (!(inFullScreenMode$ | async)) {
        <app-footer
          class="footer"
          [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
      }
    </div>
  </div>
</main>
